
































































import { component as FetchDataComposer } from '@/composers/fetch-data';
import { component as StoreRegisterComposer } from '@/composers/store-register';
import store from '../../store/products';
import View from './View';

const storeName = 'products';

export default FetchDataComposer(
  StoreRegisterComposer(
    storeName,
    store,
    View(storeName),
  ),
) as IView;
